// Sanity's image CDN resizes on the fly, so the product grid can request
// roughly the displayed size instead of downloading the full-size upload.
export const sanityImage = (url, width) => {
  if (!url || !url.includes("cdn.sanity.io")) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}w=${width}&fit=max&auto=format`;
};
